exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".noticeWarp .noticeWarp-item {\n  background-image: -webkit-gradient(linear, left top, right top, from(#010000), to(#c79015));\n  background-image: -webkit-linear-gradient(left, #010000, #c79015);\n  background-image: -o-linear-gradient(left, #010000, #c79015);\n  background-image: linear-gradient(to right, #010000, #c79015);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1cae82","@brand-primary-tap":"#1DA57A"}}!./src/components/showNotice/index.less
// module id = 511
// module chunks = 0